// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/MessagingChatClientes_UnlinkResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for POST /config/messaging_chat_clientes/unlink.
 *
 * Returns a flag indicating whether the model successfully removed the link.
 * The original endpoint emitted `success` from the model result and surfaced
 * the failure path via the same envelope (success: true with the model's bool
 * inside dados, plus a localised message). After the migration the message
 * stays in the envelope `error` slot via `sendError()` for the false branch.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface MessagingChatClientes_UnlinkResponseDados {
unlinked: boolean
}

export type MessagingChatClientes_UnlinkResponse = ApiResponse<MessagingChatClientes_UnlinkResponseDados>;

registerResponseContract('MessagingChatClientes_UnlinkResponse', {
  unlinked: { type: 'boolean', required: true },
})
